import { createSvgIcon } from '@mui/material';

export const InfoError = createSvgIcon(
  <svg
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor">
    <g clipPath="url(#clip0_3624_52540)">
      <path
        d="M7.00008 9.33268V6.99935M7.00008 4.66602H7.00591M12.8334 6.99935C12.8334 10.221 10.2217 12.8327 7.00008 12.8327C3.77842 12.8327 1.16675 10.221 1.16675 6.99935C1.16675 3.77769 3.77842 1.16602 7.00008 1.16602C10.2217 1.16602 12.8334 3.77769 12.8334 6.99935Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3624_52540">
        <rect width="100%" height="100%" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>,
  'InfoError',
);
